module.exports = __webpack_public_path__ + "img/hr-tree-04-h-trunk.47520d81.png";